import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { startLearning } from '../auth/target-exam/target-exam.component';
import { cbseRegistration } from '../auth/verify-otp/verify-otp.component';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { TermsAndConditionsDialogComponent } from '../terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { allowedExamNamesILITE, homeRoute, tenant, curTenantDetails, apisDataCacheKeys, studentDashboard } from '@app-constants/app.constants';
import { clearLocalStorage, getILCookie, setILCookie, setLoggedInUserData, getIpAddress, isUserAdmin } from 'src/app/helpers/functions';
import { AuthService } from '@app-services/auth-service/auth.service';
import { Location } from '@angular/common';
import { environment } from '@app-environments/environment';
import { LoginService } from '@app-services/login/login.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import {BoardsService} from '@app-services/boarrds/boards.service';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import * as moment from 'moment';


@Component({
  selector: 'app-enrollnow',
  templateUrl: './enrollnow.component.html',
  styleUrls: ['./enrollnow.component.css'],
})
export class EnrollnowComponent implements OnInit {
  enrollnowForm!: FormGroup;
  otpSent: boolean = false;
  otp: any;
  time: number = 0;
  restime: number = 0;
  resendotp: boolean = false;
  counter;
  otpValid: boolean = false;
  otpError: boolean = false;
  isOtpVerified = false;
  userId: any;
  userData: any;
  queryParams: any;
  navExtra;

  urlData: any = {};
  isILITE = false;
  isCBSE = false;
  gradesFetched: boolean;
  isCallBack: boolean = false;
  bookCounsel: boolean = false;
  passwordReseted = false;
  cbseRegistration = cbseRegistration;
  startLearning = startLearning;
  packageDeatails: any = [];
  examName:any;
  grades:any;
  updatedUser:any;
  tenant:any;
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;
  isExitingUser:boolean = false;
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public singupService: SignupService,
    private userService: UserService,
    private gaService: GAnalyticsService,
    private authService: AuthService,
    private location: Location,
    private loginService: LoginService,
    private SubscriptionService: SubscriptionService,
    private targetExamService: BoardsService,
    private firebaseService: FirebaseService
  ) {
    this.navExtra = this.router.getCurrentNavigation()?.extras?.state;
    let _params = { ...(this.activatedRoute.snapshot.queryParams || {}) };
    this.queryParams = { ..._params };
    console.log(this.queryParams);
    if(_params?.utm_source == "BajajFinserv" || (Array.isArray(_params?.utm_source) && _params?.utm_source?.[0] == "BajajFinserv")) {
      sessionStorage.setItem("isFromBajajFinservAppInApp", "true");
    }
   
    if(this.queryParams?.tenant){
      localStorage.setItem('tenantFromUrl', this.queryParams?.tenant);
      localStorage.setItem('SelectedTab', 'enrollnow');
      this.tenant = this.queryParams?.tenant;
    }


    var param = {
      examName: this.queryParams?.examName,
      year: this.queryParams?.year,
      producttype: 'assessment,liveclasses,recordedcourse,hardware,selflearn',
      grade: this.queryParams?.grade,
      // courseId: this.queryParams?.courseId,
    }
    // this.year = this.queryParams.year;
    let grade = this.queryParams.grade;
    localStorage.setItem('grade', this.queryParams.grade);
    this.SubscriptionService.getPackageDetails(param, grade).subscribe((result: any) => {
      this.packageDeatails = result.find(element=> element.id == this.queryParams?.id);
      localStorage.setItem('packageDetails', JSON.stringify(this.packageDeatails));
    });

    let token = localStorage.getItem('token');

    if(token){
      clearLocalStorage();
      window.location.reload();
      return;
    }
  }

  ngOnInit(): void {
    let token = localStorage.getItem('token');
    // if(token){
    //   var param = {
    //     examName: this.queryParams?.examName,
    //     year: this.queryParams?.year,
    //     producttype: 'assessment,liveclasses,recordedcourse,hardware,selflearn',
    //     grade: this.queryParams?.grade,
    //     // courseId: this.queryParams?.courseId,
    //   }
    //   let grade =this.queryParams?.grade;
    //   this.SubscriptionService.getPackageDetails(param, grade).subscribe((result: any) => { 
    //     let packageDetails = result.find(ele=>ele.id == this.queryParams?.id);
    //     var userDetails = localStorage.getItem(apisDataCacheKeys.userDetails)
    //     ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
    //     : {};
    //     let body = { ...userDetails,
    //       exams: [this.examName.find((ind) =>ind.name.replace(/[^a-z]/ig,'').toUpperCase() == this.queryParams?.examName)],
    //       grade: this.grades.find((ind) =>ind.name.toLowerCase() == this.queryParams?.grade+'th')    
    //     }
    //     console.log(body);
    //     this.userService.updateUserDetails(body).subscribe(resp=>{
    //       console.log(resp);
    //       this.updatedUser = resp;
    //       localStorage.setItem('infinity_usertype', JSON.stringify(resp.userDto.userType));
    //       localStorage.setItem('user_details_from_server', JSON.stringify(resp.userDto))
    //       localStorage.setItem('targetExamName', this.queryParams.examName);
    //       this.routeToplanPage(packageDetails);
    //     })
    //   });
    // }
    this.enrollNowForm();
    this.getExams();
    this.getGrades();
    getIpAddress();
  }

  onOtpChange(event) {
    if (event.length === 4) {
      this.otp = event;
      this.otpValid = true;
    } else {
      this.otpValid = false;
    }
  }
  startCountdown(seconds) {
    this.counter = seconds;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter == 0) {
        this.resendotp = true;
        clearInterval(interval);
      }
    }, 1000);
  }

  stopCountdown(seconds) {
    this.counter = seconds;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter == 0) {
        window.location.reload();
        clearInterval(interval);
      }
    }, 1000);
  }

  get enroll() {
    return this.enrollnowForm.controls;
  }
  enrollNowForm() {
    this.enrollnowForm = this.fb.group({
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      whatsappConsent: [true, [Validators.required]],
    });
  }

  verifyPhone() {
    this.otpSent = true;
    this.resendotp = false;
    this.startCountdown(59);
    if (
      this.enrollnowForm?.value?.phone &&
      !this.enrollnowForm?.get('phone')?.errors
    ) {
      console.log(this.enrollnowForm.value.phone);

      let phone: any = { phone: Number(this.enrollnowForm.value.phone) };

      let logData = {
        dialCode: '+91',
        number: Number(this.enrollnowForm.value.phone),
      };
      this.singupService.verifyPhoneNumber(logData).subscribe((data) => {
        console.log(data.existingUser);
        this.isExitingUser = data?.existingUser;
        if (data.existingUser === true) {
          console.log('existinguser');

          this.gaService.webEngageEvent({
            event: 'Payment otp count',
            first_name: this.enrollnowForm.value.firstName,
            last_name: this.enrollnowForm.value.lastName,
            phone: this.enrollnowForm.value.phone,
          })
          this.singupService.generateOtp(phone, '+91').subscribe((result) => {
            console.log(result);
          });
        } else {
          console.log('newuser');
          let data = {
            firstName: this.enrollnowForm.value.firstName,
            lastName: this.enrollnowForm.value.lastName,
            phone: this.enrollnowForm.value.phone,
            whatsappConsent: this.enrollnowForm.value.whatsappConsent,
            isdCode: '+91',
            courses: this.queryParams.courses,
            gradeId: this.grades?.find((ind) =>ind?.name?.toLowerCase() == this.queryParams?.grade+'th')?.gradeId,
            register: true,
          }
          this.singupService.generateOtp(data, '+91').subscribe((result) => {
            console.log(result);
          });
          this.gaService.webEngageEvent({
            event: 'Payment otp count',
            first_name: this.enrollnowForm.value.firstName,
            last_name: this.enrollnowForm.value.lastName,
            phone: this.enrollnowForm.value.phone,
          })
        }
      });
    }
  }

  verifyOtp() {
    // this.isOtpVerified = true;
    // this.otpError = true;
    let request = {
      isdCode: '+91',
      phone: this.enrollnowForm?.value?.phone,
      userOtp: this.otp,
    };
    let payload = {
      countryCode: request.isdCode,
      phone: request.phone,
      otp: request.userOtp,
      userActivityTrackingDataDto: 
      !this.sendTrackAPIOnSignInOrSignUp 
        ? undefined 
        : this.queryParams?.tenant
          ? {
            data: { 
              page: 'Success-Centres',
              actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
              utm_url: document.referrer + this.queryParams?.page + '&' + 'utm_Id=' + this.queryParams?.utm_id + '&' + 'utm_term=' + this.queryParams?.utm_term+ '&' + 'utm_source=' + this.queryParams?.utm_source+ '&' + 'utm_medium=' + this.queryParams?.utm_medium+ '&' + 'utm_campaign=' + this.queryParams?.utm_campaign+ '&' + 'utm_content=' +  this.queryParams?.utm_content+ '&'  + 'utm_campaingn_id=' + this.queryParams?.campaign_id,
              utm_id: this.queryParams?.utm_id || this.queryParams?.campaign_id,
              utm_term: this.queryParams?.utm_term,
              utm_source: this.queryParams?.utm_source,
              utm_medium: this.queryParams?.utm_medium,
              utm_campaign: this.queryParams?.utm_campaign,
              utm_content: this.queryParams?.utm_content, 
            },
            landingPage: "Success-Centres" 
          }
        :(this.queryParams?.utm_source  || this.queryParams?.utm_campaign)
          ? {
            data: { 
              page: this.queryParams?.page,
              actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
              utm_url: studentDashboard + this.queryParams?.page + '&' + 'utm_Id=' + this.queryParams?.utm_id + '&' + 'utm_term=' + this.queryParams?.utm_term+ '&' + 'utm_source=' + this.queryParams?.utm_source+ '&' + 'utm_medium=' + this.queryParams?.utm_medium+ '&' + 'utm_campaign=' + this.queryParams?.utm_campaign+ '&' + 'utm_content=' +  this.queryParams?.utm_content+ '&'  + 'utm_campaingn_id=' + this.queryParams?.campaign_id,
              utm_id: this.queryParams?.utm_id || this.queryParams?.campaign_id,
              utm_term: this.queryParams?.utm_term,
              utm_source: this.queryParams?.utm_source,
              utm_medium: this.queryParams?.utm_medium,
              utm_campaign: this.queryParams?.utm_campaign,
              utm_content: this.queryParams?.utm_content, 
            },
            landingPage: this.queryParams?.page 
          }
          :{
            data: { 
              page: `${this.queryParams.courses}-Web`,
              actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
            },
            landingPage: `${this.queryParams.courses}-Web`
          },
    };
    this.singupService
      .validateOtp(payload)
      .subscribe(
        (data) => {
          console.log(data);
          if (data?.accessToken) {
            console.log(data?.accessToken)
            this.isOtpVerified = true;
            // this.userService.setCookie(
            //   'INFINITY_LEARN',
            //   JSON.stringify(data),
            //   1
            // );
          
          this.userId = data.userDto.userId;
          console.log(this.userId);
          this.userData = data;
          localStorage.setItem('token', data.accessToken);
          localStorage.setItem('studentId', data.userDto.phone);
          let userInfo: any = {
            firstName: data.userDto.firstName,
            grade: this.queryParams.gradeId,
            isdCode: data.userDto.isdCode,
            lastName: data.userDto.lastName,
            phone: data.userDto.phone,
            profilePhoto: data.userDto.profilePhoto,
            userId: data.userDto.userId,
            whatsappConsent: true,
          }
          localStorage.setItem('mobile_and_name', JSON.stringify(userInfo));
          localStorage.setItem('infinity_usertype', JSON.stringify(data.userDto.userType));
          localStorage.setItem('user_details_from_server', JSON.stringify(data.userDto))
          localStorage.setItem('targetExamName', this.queryParams.examName);
          let body = { ...data?.userDto,
            exams: [this.examName.find((ind) =>ind.name.replace(/[^a-z]/ig,'').toUpperCase() == this.queryParams?.examName)],
            grade: this.grades.find((ind) =>ind.name.toLowerCase() == this.queryParams?.grade+'th')    
          }
          console.log(body);
          this.userService.updateUserDetails(body).subscribe(res=>{
            console.log(res);
            this.updatedUser = res;
            this.sendSQS(res?.userDto);
          })
          if (this.navExtra?.register) {
            this.gaService.webEngageEvent({
              event: 'SignUp',
              phone: data.userDto.phone,
              whatsapp_consent: data.userDto.whatsappConsent,
              first_name: data.userDto.firstName,
              last_name: data.userDto.lastName,
              grade: data?.userDto?.grade?.name
                ?.replace('st', '')
                ?.replace('nd', '')
                ?.replace('rd', '')
                ?.replace('th', ''),
              exam_name: '',
              pick_a_date: '',
              target_year: null, // Data type should be number
              subject: '',
            });
          }
        } else{
          console.log('worng-otp')
          this.otpError = true;
        }
        },
        (error: any) => {
          console.log('worng otp');
          this.otpError = true;
          this.stopCountdown(58);
          // window.location.reload();
          
        }
      );
  }

  enrollNow() {
    console.log(this.enrollnowForm.value);
    setLoggedInUserData(this.updatedUser, this.userService, this.authService);
    let _headers = {
      'accesstoken': this.userData.accessToken,
      'studentid': `${this.userData.phone}`,
      // 'methodtype': 'RULES'
    };
    if(!this.sendTrackAPIOnSignInOrSignUp) {
      isUserAdmin(this.userService).then((bool) => {
        if(!bool) {
          if(this.queryParams?.tenant) {
            this.userService
            .callTrackingAPI(this.userData.userDto.userId, {
              data: { page: 'Success-Centres',
                      actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
                      utm_url: document.referrer + this.queryParams?.page + '&' + 'utm_Id=' + this.queryParams?.utm_id + '&' + 'utm_term=' + this.queryParams?.utm_term+ '&' + 'utm_source=' + this.queryParams?.utm_source+ '&' + 'utm_medium=' + this.queryParams?.utm_medium+ '&' + 'utm_campaign=' + this.queryParams?.utm_campaign+ '&' + 'utm_content=' +  this.queryParams?.utm_content+ '&'  + 'utm_campaingn_id=' + this.queryParams?.campaign_id,
                      utm_id: this.queryParams?.utm_id || this.queryParams?.campaign_id,
                      utm_term: this.queryParams?.utm_term,
                      utm_source: this.queryParams?.utm_source,
                      utm_medium: this.queryParams?.utm_medium,
                      utm_campaign: this.queryParams?.utm_campaign,
                      utm_content: this.queryParams?.utm_content, 
                    },
            }).subscribe(() => {});
          } else if(this.queryParams?.utm_source  || this.queryParams?.utm_campaign){
            this.userService
            .callTrackingAPI(this.userData.userDto.userId, {
              data: { page: this.queryParams?.page,
                      actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
                      utm_url: studentDashboard + this.queryParams?.page + '&' + 'utm_Id=' + this.queryParams?.utm_id + '&' + 'utm_term=' + this.queryParams?.utm_term+ '&' + 'utm_source=' + this.queryParams?.utm_source+ '&' + 'utm_medium=' + this.queryParams?.utm_medium+ '&' + 'utm_campaign=' + this.queryParams?.utm_campaign+ '&' + 'utm_content=' +  this.queryParams?.utm_content+ '&'  + 'utm_campaingn_id=' + this.queryParams?.campaign_id,
                      utm_id: this.queryParams?.utm_id || this.queryParams?.campaign_id,
                      utm_term: this.queryParams?.utm_term,
                      utm_source: this.queryParams?.utm_source,
                      utm_medium: this.queryParams?.utm_medium,
                      utm_campaign: this.queryParams?.utm_campaign,
                      utm_content: this.queryParams?.utm_content, 
                    },
            }).subscribe(() => {});
            } else {
              this.userService.callTrackingAPI(this.userData.userDto.userId, 
                {
                data: 
                { page: `${this.queryParams.courses}-Web`,
                actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
                }}).subscribe();
            } 
        }
      })
    }
    this.saveAccessToken(_headers,)
    this.gaService.webEngageEvent({
      event: 'Payment Initiated',
      first_name: this.userData.userDto.firstName,
      last_name: this.userData.userDto.lastName,
      phone: this.userData.userDto.phone,
      whatsapp_consent: this.userData.userDto.whatsappConsent,
    })


    let details = localStorage.getItem('packageDetails');
    if (this.userData.accessToken) {
      // this.router.navigate(['/dashboard'],{ state: { newUser:true } });
      // this.router.navigate(['/subscription/subscriptionPackages']);
      this.routeToplanPage(JSON.parse(this.getPackageDetails()));
    }

    // this.singupService.verifyPhoneNumber(logData).subscribe((data) => {

    //   if(data.existingUser){
    //     this.router.navigate(['/dashboard'],{ state: { newUser:true } });
    //   }

    // });

    // this.router.navigate(['/target-exam']);
  }

  routeToplanPage(pack: any) {
    this.SubscriptionService.subscriptionSelectedData.liveclass_courseID =
      pack?.packagesCourseDtoList?.[0]?.courseId ? (pack?.courseId == 1 ? null : pack?.courseId) : null;
    pack.packageName = pack?.name;
    pack.amount = pack?.maxValue;
    pack.validDate = pack?.packageValidity;
    this.router.navigate(['../enroll-subscription/enroll-proceed-to-payment'], {
      state: { ...pack },
    });

    let arr = { "selectedPackage": pack };
    localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(arr));
  }

  saveAccessToken(_headers: any, navigateToDashboard?: any): any {
    let route = '/subscription/subscriptionPackages';
    let userType = this.userService.getUserType()
    if (userType == 2) {
      route += '/liveclass';
    }
    else {
      // if (environment?.portal == 'teacher') {
      //   this.loginService.logoutEvent.emit({ showPopup: true, message: 'Oops!', message2: `Seems like you are not a registerd teacher.` });
      //   return;
      // }
    }
    // this.router.navigate([route])
    // let details = localStorage.getItem('packageDetails');
    this.routeToplanPage(JSON.parse(this.getPackageDetails()));
  }

  editNum() {
    window.location.reload();
  }

  getPackageDetails(){
    return localStorage.getItem('packageDetails');
  }

  openTermsAndConditionsDialog(): void {
    const config: MatDialogConfig = {
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' },
    };
    const dialogRef = this.dialog.open(
      TermsAndConditionsDialogComponent,
      config
    );
  }

  openPrivacyPolicyDialog() {
    const config: MatDialogConfig = {
      // width: '557px',
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' },
    };
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, config);
  }

  openCallBackDialog(phone) {
    let titleText;
    this.isCallBack ? titleText = 'Your request for a call back has been sent.' : titleText = 'Your request for free counselling session has been sent.'
    const config: MatDialogConfig = {
      width: '400px',
      height: '290px',
      data: {
        phone: phone,
        title: titleText
      },
    };
    this.router.navigate(['/dashboard'])
    // let dialogRef = this.dialog.open(CallbackSuccessComponeent, config)
    // dialogRef.afterClosed().subscribe((res) => {
    //   this.router.navigate(['/dashboard'])
    // })
  }

  checkGradeAvailabllility(_params, type) {
    if (!_params.grade || curTenantDetails['allowedGrades'].indexOf(_params.grade?.replace(/[^0-9]/g, '')) < 0) {
      window.location.href = homeRoute + type;
      return;
    }
  }

  getGrades(){
    this.targetExamService.fetchGradesList().subscribe(res=>{
      console.log(res);
      this.grades =res;
    })
  }
  getExams(){
    this.targetExamService.fetchTargetExamList().subscribe(res=>{
     res.forEach(ele=>{
        console.log(ele.name.replace(/[^a-z]/ig,'').toUpperCase())
      })
      this.examName = res;
      console.log(this.examName)
    })
  }

  sendSQS(userData){
    this.firebaseService.getWebsiteSqsValue().then((firebaseRSP)=>{
      let fields = {
        SourceCampain : this.queryParams?.utm_campaign || undefined,
        SourceMedium : this.queryParams?.utm_medium || undefined,
        SourceContent : this.queryParams?.utm_content || undefined,
        mx_Custom_1: this.queryParams?.utm_url || undefined,
        mx_Custom_2: this.queryParams?.utm_source || undefined,
        mx_Custom_3: this.queryParams?.utm_campaign || undefined,
        mx_Custom_4: this.queryParams?.utm_medium || undefined,
        mx_Custom_5: this.queryParams?.utm_content || undefined,
        mx_Custom_6: this.queryParams?.utm_id || undefined,
        mx_Custom_7: this.queryParams?.utm_term || undefined,
        mx_Custom_8 :`${this.queryParams.courses}-Web` || undefined,
        mx_Grade: Number(userData?.grade?.name?.replace(/[a-z]/ig,'')) || undefined,
        mx_Exam: userData?.exams?.[0]?.name?.replace(/[^a-z]/ig,'').toUpperCase() || undefined,
        mx_Primary_Target_Exam: userData?.exams?.[0]?.name?.replace(/[^a-z]/ig,'').toUpperCase() || undefined,
        mx_Actual_source_URL: window.location.href,
      }
      let firebasePayload = {
        "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
        "Fields": fields,
        "FirstName": userData?.firstName,
        "LastName": userData?.lastName,
        "environment": environment?.branch,
        "phone": userData?.phone,
        "Source": "IL Website",
        "productId": 1,
        "type": "Lead"
      }
      console.log(firebasePayload)
      this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload)
    })
  }
}
